import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAppSelector } from "./Redux/hooks";
import { useQuery } from "./utils/hooks";
import MagicLink from "./Components/Auth/MagicLink";

const LinkParticipant = () => {
  const isAuthenticated = useAppSelector(
    (state) => state.user.isUserAuthenticated
  );
  const role = useAppSelector((state) => state.user.role);
  const { type } = useParams();
  const query = useQuery();
  const location = useLocation();

  if (type === "consent") {
    const consentId = query.get("consentId");
    const versionId = query.get("versionId");
    const studyId = query.get("studyId");
    const tokenId = query.get("tokenId");

    return (
      <MagicLink
        studyId={studyId}
        consentId={consentId}
        versionId={versionId}
        tokenId={tokenId}
      />
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={"/auth/participant/login"}
        state={{ from: location }}
        replace
      />
    );
  }

  if (role !== "participant") {
    return <Navigate to={"/home"} replace />;
  }

  if (type === "epro") {
    return <Navigate to={`/participant/questionnaires`} replace />;
  }

  return <Navigate to={"/home"} replace />;
};

export default LinkParticipant;
